import * as Sentry from "@sentry/react";
import React from "react";

import CalendarIntegration from "./components/CalendarIntegration";

import { getFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

import { companyCalendarIntegrationSettingsQuery, currentUserQuery } from "../../../api/queries";
import { dataLoader } from "../../../api/queries/dataLoader";

export const calendarIntegrationSettingsLoader = () => {
	const queries = [companyCalendarIntegrationSettingsQuery, getFeatureFlagQuery];

	return dataLoader([[currentUserQuery], queries]);
};

const AdminCalendarIntegration = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<CalendarIntegration />
		</Sentry.ErrorBoundary>
	);
};

export default AdminCalendarIntegration;
